import { render, staticRenderFns } from "./ConsultancyProfile.vue?vue&type=template&id=48445930&"
import script from "./ConsultancyProfile.vue?vue&type=script&lang=js&"
export * from "./ConsultancyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports